<template>
    <div>
        <h2>Your contact info</h2>

        <div class="signup-form__field">
            <label for="signup-name" class="signup-form__label">Full name <span class="signup-form__required">*</span></label>
            <input
                type="text"
                class="signup-form__input"
                id="signup-name"
                v-model="state.form.name"
                required
                autocomplete="name"
            />
            <span v-if="error('name')" class="signup-form__error" role="alert">{{ error('name') }}</span>
        </div>

        <div class="signup-form__field">
            <label for="signup-email" class="signup-form__label">Email <span class="signup-form__required">*</span></label>
            <input
                type="email"
                class="signup-form__input"
                id="signup-email"
                v-model="state.form.email"
                required
                autocomplete="email"
            />
            <span v-if="error('email')" class="signup-form__error" role="alert">{{ error('email') }}</span>
        </div>

        <div class="signup-form__field">
            <label for="signup-phone" class="signup-form__label">Phone <span class="signup-form__required">*</span></label>
            <input
                type="tel"
                class="signup-form__input"
                id="signup-phone"
                v-model="state.form.phone"
                required
                autocomplete="tel"
            />
            <span v-if="error('phone')" class="signup-form__error" role="alert">{{ error('phone') }}</span>
        </div>

        <!-- Honeypot: hidden from real users, attractive to bots -->
        <input
            type="text"
            name="companyWebsite"
            v-model="state.form.companyWebsite"
            tabindex="-1"
            autocomplete="off"
            aria-hidden="true"
            style="display:none;"
        />
    </div>
</template>

<script setup>
import useState from '@/composables/useState';

const { state } = useState();

const error = (field) => state.serverErrors[field]?.[0];
</script>
